import { combineReducers, Reducer } from '@reduxjs/toolkit';
import invoiceReducer from './features/invoice/invoiceSlice';
import type { InvoiceState } from './features/invoice/invoiceSlice';
import createAccountReducer from './features/account/accountSlice';
import type { AccountState } from './features/account/accountSlice';
import transactionReducer, { TransactionState } from './features/transaction/transactionSlice';

// Define root state type
export interface RootState {
  invoice: Reducer<InvoiceState>;
  account: Reducer<AccountState>;
  transaction: Reducer<TransactionState>;
  // Add other state interfaces here
}

// Combine all reducers
const rootReducer = combineReducers({
  invoice: invoiceReducer,
  account: createAccountReducer,
  transaction: transactionReducer,
  // Add other reducers here
});

export default rootReducer;
